<template>
  <div class="resource-page">
    <el-image
      class="banner pc"
      fit="cover"
      :src="require('@/assets/images/csmz/resource_banner.jpg')"
    ></el-image>
    <el-image
      class="banner mobile"
      fit="cover"
      :src="require('@/assets/images/csmz/resource_banner_mobile.png')"
    ></el-image>
    <div class="white-bg content self-content">
      <div class="container">
        <h1 class="title">
          <span class="line"></span>
          德育工作资源库
        </h1>
        <p class="desc">
          依托全国职业院校思政创新百校联合行动，建设全国职业院校德育工作资源库，深入宣传全国职业院校德育、思政创新工作，推广职业院校在德育工作方面可复制可推广的经验与做法，在全国形成示范引领作用。
        </p>
        <resourceMenus />
      </div>
    </div>
    <div class="gray-bg content">
      <div class="container">
        <ResourceItem :resources="resources" :mode="1" />
      </div>
    </div>
    <div class="white-bg content">
      <div class="container">
        <ResourceItem :resources="resources" :mode="2" />
      </div>
    </div>
    <Footer class="isGray" />
  </div>
</template>
<script>
import "../plugins/element/element.js";
import Footer from "../components/Footer.vue";
import ResourceItem from "../components/resourceItem.vue";
import resourceMenus from "../components/resourceMenus.vue";
import { getResList } from "@/api/api.js";
import util from "@/libs/util.js";
export default {
  name: "resource",
  data() {
    return {
      resources: [
        {
          folderId: 42149,
          title: "思政教育体制机制创新最新资源",
          list: [],
        },
        {
          folderId: 42150,
          title: "思政理论课改革最新资源",
          list: [],
        },
        {
          folderId: 42151,
          title: "课程思政改革最新资源",
          list: [],
        },
        {
          folderId: 42427,
          title: "文化育人最新资源",
          list: [],
        },
      ],
    };
  },
  created() {
    util.setTitle("favicon-csmz.ico","德育工作资源库")
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        keyword: "",
        libraryId: 351,
        type: "",
        year: "",
        labelId: "",
        catalog1: "",
        catalog2: "",
        catalog3: "",
        catalog4: "",
        catalog5: "",
        order: "publishTime",
        desc: 1,
        pn: 1,
        ps: 5,
        folderId: "",
      };
      for (let i = 0; i < 4; i++) {
        let data = JSON.parse(JSON.stringify(params));
        data.folderId = this.resources[i].folderId;
        getResList(data)
          .then((res) => {
            if (res && res.resourceList && res.resourceList.length > 0) {
              this.resources[i].list = res.resourceList;
            } else {
              this.resources[i].list = [];
            }
          })
          .catch((err) => {
            this.resources[i].list = [];
            console.log(err);
          });
      }
    },
  },
  components: {
    Footer,
    ResourceItem,
    resourceMenus,
  },
};
</script>
<style lang="scss" scoped>
.resource-page {
  text-align: center;
  .container {
    overflow: hidden;
  }
  .banner {
    height: 300px;
    display: block;
  }
  .content {
    margin: 0 auto;
    padding: 40px 0;
    text-align: left;
    &.self-content {
      padding-bottom: 16px;
    }
    .title {
      margin-bottom: 20px;
      padding-left: 15px;
      font-size: 20px;
      color: #111111;
      line-height: 26px;
      position: relative;
      &::before {
        position: absolute;
        top: 2px;
        left: 0;
        width: 5px;
        height: 20px;
        border-radius: 2.5px;
        display: block;
        content: " ";
        background-image: -webkit-linear-gradient(bottom, #dd0000, #ffbb20);
      }
    }
    .desc {
      margin: 20px 0 8px;
      font-size: 14px;
      color: #444444;
      line-height: 28px;
    }
  }
  .gray-bg {
    background-color: #f8f8f8;
  }

  @media (max-width: 767px) {
    .content {
      padding: 20px 0;
      &.gray-bg, &.self-content {
        padding-bottom: 0;
      }
      .title {
        margin-bottom: 10px;
      }
      .desc {
        margin: 0 auto 16px;
      }
    }
  }
}
.isGray {
  background-color: #f8f8f8;
}
</style>